import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=15730337"
import script from "./list-item.vue?vue&type=script&lang=ts"
export * from "./list-item.vue?vue&type=script&lang=ts"
import style0 from "./list-item.vue?vue&type=style&index=0&id=15730337&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15730337')) {
      api.createRecord('15730337', component.options)
    } else {
      api.reload('15730337', component.options)
    }
    module.hot.accept("./list-item.vue?vue&type=template&id=15730337", function () {
      api.rerender('15730337', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/list-item.vue"
export default component.exports